import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { toInteger } from "lodash";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { corporateCMSApi, post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { usePublicationDocumentDetails } from "./Publication.hook";
import { fields } from "./contant";
const AddEditPublications = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [records, setRecords] = useState<any[]>([]);
  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = usePublicationDocumentDetails(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");
  const getRecords = () => {
    let url = `/api/get-publication-cards/all-fields`;
    corporateCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setRecords(envelopes);
        }
      })
      .catch((err) => {
        setRecords([]);
      });
  };

  useEffect(() => {
    getRecords();
  }, []);

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);

  const LargeCardFormConfig: FormConfig = {
    initialValues: {
      status: dataById ? decodeHTML(dataById.payload?.status) : editData ? decodeHTML(editData?.status) : false,
      sequence: dataById ? decodeHTML(dataById?.payload?.sequence) : decodeHTML(editData?.sequence),
      title: dataById ? decodeHTML(dataById.payload.title) : editData ? decodeHTML(editData?.title) : "",
      field_publication_title_ms: dataById
        ? decodeHTML(dataById.payload.field_publication_title_ms)
        : editData
          ? decodeHTML(editData?.field_publication_title_ms)
          : "",
      field_publication_title_zh: dataById
        ? decodeHTML(dataById.payload.field_publication_title_zh)
        : editData
          ? decodeHTML(editData?.field_publication_title_zh)
          : "",
      field_publication_desc_en: dataById
        ? decodeHTML(dataById.payload.field_publication_desc_en)
        : editData
          ? decodeHTML(editData?.field_publication_desc_en)
          : "",
      field_publication_desc_ms: dataById
        ? decodeHTML(dataById.payload.field_publication_desc_ms)
        : editData
          ? decodeHTML(editData?.field_publication_desc_ms)
          : "",
      field_publication_desc_zh: dataById
        ? decodeHTML(dataById.payload.field_publication_desc_zh)
        : editData
          ? decodeHTML(editData?.field_publication_desc_zh)
          : "",
      field_publication_redirect_url: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "publication.pdf",
              status: "done",
              url: dataById?.payload?.field_publication_redirect_url,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "pubication.pdf",
              status: "done",
              url: editData?.field_publication_redirect_url,
            },
          ]),
      field_publication_redirect_ms: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "pubication.pdf",
              status: "done",
              url: dataById?.payload?.field_publication_redirect_ms,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "pubication.pdf",
              status: "done",
              url: editData?.field_publication_redirect_ms,
            },
          ]),
      field_publication_redirect_zh: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "pubication.pdf",
              status: "done",
              url: dataById?.payload?.field_publication_redirect_zh,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "pubication.pdf",
              status: "done",
              url: editData?.field_publication_redirect_zh,
            },
          ]),
      field_publication_image: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: dataById?.payload?.field_publication_image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: editData?.field_publication_image,
            },
          ]),
    },
    fields: fields.publications.map((field: any) => {
      if (field.name === "sequence") {
        return {
          ...field,
          validation: {
            required: `${field.label || field.name} is required`,
            validate: (value: string, formValues: FieldValues) => {
              if (!value) return true;
              const existingRecord = records.find((record: any) => {
                return (
                  toInteger(record[field.name]) === toInteger(value) &&
                  record.id !== (editData?.id || dataById?.payload?.id)
                );
              });
              return !existingRecord || `${field.label || field.name} already exists`;
            },
          },
        };
      }
      return field;
    }),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data", data);
    let imageKeys: any = [
      "field_publication_image",
      "field_publication_redirect_url",
      "field_publication_redirect_ms",
      "field_publication_redirect_zh",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    // let descKeys: any = [
    //   "field_publication_desc_en",
    //   "field_publication_desc_ms",
    //   "field_publication_desc_zh",
    // ];
    // for (const key of descKeys) {
    //   try {
    //     data[key] = {
    //       value: data[key] || "",
    //       format: "full_html",
    //     };
    //   } catch (error) {}
    // }

    const payload = {
      action: action,
      method: method,
      module: "Homepage",
      subModule: `publications`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Homepage_Publications",
      payload: {
        ...(action === "UPDATE" && { id: editData?.id || dataById?.payload?.id }),
        ...data,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Publications`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={LargeCardFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            query.get("editId") || query.get("type") === "update"
              ? `${corporateHost}/api/publication-cards/${dataById?.payload?.id || editData?.id}`
              : `${corporateHost}/api/create/publication-cards`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Homepage"
      />
    </ContentWrapper>
  );
};
export default AddEditPublications;
